module.exports = __webpack_public_path__ + "static/media/GO-HEALTH-NEGATIVO.a00cddda.png";